import { stripLanguage } from "src/utils/languagePaths"

/* The tab's title for a route (owner, 2026-09-29: "why does the tab title of my browser say 'Cómo
   jugar a Zombies' when I'm in the middle of a game?").

   The server writes `<title>` into the shell per route (`backend:zombies_vs_humans/seo.py`), but it
   only ever sees the address the app was *opened* at. Every later move is the router's, so a player
   who read the Spanish manual and walked into a game kept the manual's title for the whole war.
   The client therefore sets it again on every navigation, and says what the server says wherever
   the server says something: a public page carries its seo title in the reader's language (the
   locales hold them under `documentTitle.*`, and `documentTitle.test.js` fails if they drift from
   `seo.PAGES`), and everything else is the site's name, which is what the server's private head
   writes — with the room's number or the round in front, because a player with three games open
   in three tabs is telling them apart by this line.

   Pure: the path, a `t`, and the round of the game being viewed when there is one. */
const PUBLIC_TITLE_KEYS = {
  "/": "documentTitle.home",
  "/how-to-play": "documentTitle.howToPlay",
  "/tutorial": "documentTitle.tutorial",
  "/privacy": "documentTitle.privacy",
  "/terms": "documentTitle.terms",
}

export const documentTitleFor = (pathname, t, { round = null } = {}) => {
  const path = stripLanguage(pathname)
  if (PUBLIC_TITLE_KEYS[path]) return t(PUBLIC_TITLE_KEYS[path])

  const lobby = path.match(/^\/lobby\/(\d+)$/)
  if (lobby) return t("documentTitle.lobby", { number: lobby[1] })

  if (/^\/game\/[^/]+$/.test(path)) {
    return round == null ? t("documentTitle.site") : t("documentTitle.game", { round })
  }

  if (/^\/replay\/[^/]+$/.test(path)) return t("documentTitle.replay")

  if (path === "/ranking") return t("documentTitle.ranking")

  return t("documentTitle.site")
}
